'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _sidebar = require('./sidebar');

var _sidebar2 = _interopRequireDefault(_sidebar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _sidebar2.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-sidebar/dist-modules/index.js
// module id = 1609
// module chunks = 2